import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-field',
    templateUrl: './field.component.html',
    styleUrls: ['./field.component.css'],
    standalone: false
})
export class FieldComponent {
  @Input() title: string;

  constructor() {
  }
}
